'use strict';

exports.__esModule = true;
exports.VALUE_VALIDATOR_SYMBOL = undefined;

var _sym = require('./sym');

var _sym2 = _interopRequireDefault(_sym);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALUE_VALIDATOR_SYMBOL = exports.VALUE_VALIDATOR_SYMBOL = (0, _sym2.default)('VALUE_VALIDATOR'); /* eslint-disable import/prefer-default-export */


//////////////////
// WEBPACK FOOTER
// ./node_modules/revalidate/lib/internal/symbols.js
// module id = 788
// module chunks = 204